var _rect, _rect2, _rect3, _text, _text2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 192,
    fill: "#c8ff00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 168,
    width: 336,
    height: 688,
    rx: 48,
    fill: "#27272a"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 544,
    y: 168,
    width: 336,
    height: 688,
    rx: 48,
    fill: "#27272a",
    opacity: 0.5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 312,
    y: 570,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 280,
    fontWeight: 800,
    fill: "#c8ff00",
    textAnchor: "middle"
  }, "A")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 712,
    y: 570,
    fontFamily: "system-ui, -apple-system, sans-serif",
    fontSize: 280,
    fontWeight: 800,
    fill: "#c8ff00",
    textAnchor: "middle",
    opacity: 0.7
  }, "B")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dabd458b39cdfb8f0cb390df936b80f7.svg";
export { ForwardRef as ReactComponent };